import { Grid } from '@mui/material';

import NewSearchField from 'components/filters/NewFiltersParams/NewSearchField';

import type { CopartSearchProps } from './types';
import { CopartPreviewExportButton } from './components';

export const CopartSearch = ({ isLoading }: CopartSearchProps) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={12} md={9} lg={9} xl={10}>
        <NewSearchField
          name="search"
          currentResultLength={0}
          placeholder="Buscar por nome, carteirinha e CPF"
          disableSearch={isLoading}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={3} lg={3} xl={2}>
        <CopartPreviewExportButton />
      </Grid>
    </Grid>
  );
};
